import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-483ee668"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-validation-component electionTerapeuta" }
const _hoisted_2 = { class: "row justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "column items-center control",
  style: {"padding-bottom":"33px"}
}
const _hoisted_4 = {
  key: 1,
  class: "column items-center control"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-weight-extrabold text-center subtitle text-gray8" }, " Ingresa la clave que el terapeuta te dió ", -1))
const _hoisted_6 = { class: "idCont" }
const _hoisted_7 = {
  key: 2,
  class: "column items-center control"
}
const _hoisted_8 = {
  key: 3,
  class: "row justify-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-12 text-center q-pt-md subtitle" }, " Validando código de terapeuta ", -1))
const _hoisted_10 = {
  key: 4,
  class: "full-width column items-center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-weight-extrabold text-center col-5 subtitle text-secondary q-ma-none" }, " Terapeuta elegido ", -1))
const _hoisted_12 = { class: "row justify-center q-pt-sm" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "column q-pl-sm q-pr-md q-pt-sm" }
const _hoisted_15 = { class: "text-weight-bold text-center title text-primary q-ma-none q-pt-xs" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-weight-light subtitle text-gray8 q-ma-none q-pl-xs q-pt-xs" }, " Código de Terapeuta ", -1))
const _hoisted_17 = {
  key: 5,
  class: "full-width column items-center"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-weight-extrabold text-center col-5 subtitle text-secondary q-ma-none" }, " Terapeuta elegido ", -1))
const _hoisted_19 = { class: "row justify-center q-pt-sm" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "column q-pl-sm q-pr-md q-pt-sm" }
const _hoisted_22 = { class: "text-weight-bold text-center title text-primary q-ma-none q-pt-xs" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-weight-light subtitle text-gray8 q-ma-none q-pl-xs q-pt-xs" }, " Terapeuta ", -1))

import {
  ref, watch, reactive, PropType, computed,
} from 'vue';
import { RegisterPacientePersonalData } from 'src/types/initial-evaluation/evaluacion-personal';
import { QField } from 'quasar';
import { api, AxiosError, logAxiosErrors } from 'src/boot/axios';
import to from 'await-to-js';
import { AxiosResponse } from 'axios';
import { TerapeutaByKeyCode } from 'src/types/PIBA/TerapeutaByKeyCode';
import { useS3Object } from 'src/composables/UseS3Object';
import { useQuasar } from 'quasar'


export default /*#__PURE__*/_defineComponent({
  __name: 'ElectionTerapeuta',
  props: {
  modelValue: {
    type: Object as PropType<RegisterPacientePersonalData['terapeutaElection']>,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

const $q = useQuasar()






// const rValue = reactive(props.modelValue);
const rValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});
const fieldRef = ref<QField>();
const terapeuta = ref<TerapeutaByKeyCode>();
const terapeutaName = computed(() => `${terapeuta.value?.names?.split(' ')[0] || ''} ${terapeuta.value?.lastNames?.split(' ')[0] || ''}`);
const { getS3Object } = useS3Object();
// watch(rValue, () => {
//   emit('update:modelValue', rValue);
// });
function validate() {
  return fieldRef.value?.validate();
}
async function verificarCodigoTerapeuta() {
  rValue.value.estado = 'ValidandoTerapeuta';
  const [err, response] = await to<AxiosResponse<TerapeutaByKeyCode>, AxiosError<{ error: string, message: string, statusCode: number }>>(api.get(`/terapeutas/verifyOne/${rValue.value.terapeuta}`));
  if (err) {
    logAxiosErrors(err);
    $q.notify({
      type: 'negative',
      message: 'Ocurrio un error validando el código de terapeuta',
    });
    if (err.response?.data.statusCode === 404) {
      rValue.value.estado = 'CodigoTerapeutaInvalido';
    } else if (err.isAxiosError) {
      rValue.value.estado = 'TerapeutaSeleccionadoSinVerificar';
    } else {
      rValue.value.estado = 'CodigoTerapeutaInvalido';
    }
  } else if (response?.data) {
    terapeuta.value = response.data;
    try {
      terapeuta.value.profile_picture = (await getS3Object(response.data.profile_picture)).url;
    } catch {
      terapeuta.value.profile_picture = '/placeholder-1.png';
    }
    rValue.value.estado = 'TerapeutaSeleccionado';
  }
}
if (props.modelValue.terapeuta) {
  verificarCodigoTerapeuta().catch(console.error.bind(console));
}

function eliminarTerapeuta() {
  rValue.value.estado = '';
  rValue.value.terapeuta = '';
}



return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_spinner_ball = _resolveComponent("q-spinner-ball")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(QField), {
        ref_key: "fieldRef",
        ref: fieldRef,
        modelValue: _unref(rValue),
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(rValue) ? (rValue).value = $event : null)),
        borderless: "",
        "stack-label": "",
        "lazy-rules": "ondemand",
        rules: [val => !!(
      val.estado === 'TerapeutaSeleccionado'
      || val.estado === 'DeseaTerapeuta'
      || val.estado === 'Independiente'
      || val.estado === 'TerapeutaSeleccionadoSinVerificar') || 'Elige una opción']
      }, {
        control: _withCtx(() => [
          (_unref(rValue).estado == null || _unref(rValue).estado === '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_q_btn, {
                  color: "secondary",
                  "no-caps": "",
                  unelevated: "",
                  rounded: "",
                  class: "button text-uppercase q-my-xs",
                  label: "Tengo un terapeuta",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(rValue).estado = 'IngresandoClaveTerapeuta'))
                }),
                _createVNode(_component_q_btn, {
                  color: "primary",
                  "no-caps": "",
                  unelevated: "",
                  rounded: "",
                  class: "button text-uppercase q-my-xs",
                  label: "No tengo un terapeuta",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(rValue).estado = 'NoTengoTerapeuta'))
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(rValue).estado === 'IngresandoClaveTerapeuta'
          || _unref(rValue).estado === 'CodigoTerapeutaInvalido')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_q_input, {
                    modelValue: _unref(rValue).terapeuta,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(rValue).terapeuta) = $event)),
                    outlined: "",
                    rounded: "",
                    class: "",
                    "label-color": "lightgray",
                    label: "Clave del terapeuta"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        class: "text-lightergray",
                        name: "fa-solid fa-address-card"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_q_btn, {
                    color: "primary",
                    unelevated: "",
                    rounded: "",
                    class: "q-ml-sm",
                    onClick: verificarCodigoTerapeuta
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: "fa-solid fa-chevron-right",
                        height: "3em",
                        class: "q-py-sm"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_q_icon, {
                  class: "title q-mt-sm text-gray8 cursor-pointer",
                  name: "fa-regular fa-circle-left",
                  onClick: eliminarTerapeuta
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(rValue).estado === 'NoTengoTerapeuta'
          || _unref(rValue).estado === 'DeseaTerapeuta'
          || _unref(rValue).estado === 'Independiente')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_unref(rValue).estado !== 'Independiente')
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      color: "accent",
                      "no-caps": "",
                      unelevated: "",
                      rounded: "",
                      class: "button text-uppercase q-my-xs",
                      label: "Quiero un terapeuta",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(rValue).estado = 'DeseaTerapeuta'))
                    }))
                  : _createCommentVNode("", true),
                (_unref(rValue).estado !== 'DeseaTerapeuta')
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      color: "primary",
                      "no-caps": "",
                      unelevated: "",
                      rounded: "",
                      class: "button text-uppercase q-my-xs",
                      label: "lo haré por mi cuenta 💪",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(rValue).estado = 'Independiente'))
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_icon, {
                  class: "title q-mt-sm text-gray8 cursor-pointer",
                  name: "fa-regular fa-circle-left",
                  onClick: eliminarTerapeuta
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(rValue).estado === 'ValidandoTerapeuta')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_q_spinner_ball, {
                  color: "primary",
                  class: "col-4",
                  size: "2em"
                }),
                _hoisted_9
              ]))
            : _createCommentVNode("", true),
          (_unref(rValue).estado === 'TerapeutaSeleccionadoSinVerificar')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_q_avatar, { class: "avatar q-pt-sm" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: terapeuta.value ? terapeuta.value.profile_picture : '/placeholder-1.png',
                        class: "avatar-outline-primary img circle-avatar-img"
                      }, null, 8, _hoisted_13)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(rValue).terapeuta), 1),
                    _hoisted_16
                  ])
                ]),
                _createElementVNode("p", {
                  class: "col-12 text-weight-light cancel text-center subtitle text-lightgray q-mt-sm",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(rValue).estado = ''))
                }, " Cancelar elección ")
              ]))
            : _createCommentVNode("", true),
          (_unref(rValue).estado === 'TerapeutaSeleccionado')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_q_avatar, { class: "avatar q-pt-sm" }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: terapeuta.value ? terapeuta.value.profile_picture : '/placeholder-1.png',
                        class: "avatar-outline-primary img circle-avatar-img"
                      }, null, 8, _hoisted_20)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(terapeutaName)), 1),
                    _hoisted_23
                  ])
                ]),
                _createElementVNode("p", {
                  class: "col-12 text-weight-light cancel text-center subtitle text-lightgray q-mt-sm",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(rValue).estado = ''))
                }, " Cancelar elección ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "rules"])
    ])
  ]))
}
}

})